import { createRouter, createWebHistory } from "vue-router";
import BeforeEach from "@/router/before-each";

import LoadingView from "@/views/public/LoadingView";
import NoOrganizationsView from "@/views/NoOrganizationsView";

import AppRouter from "@/router/app.router";
import PublicRouter from "@/router/public.router";

import gettext from "@/language";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: { name: "loading" },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: {
        name: "loading",
      },
    },
    {
      path: "/loading",
      name: "loading",
      component: LoadingView,
      meta: {
        title: gettext.$gettext("Loading"),
      },
    },
    {
      path: "/no-organizations",
      name: "no-organizations",
      component: NoOrganizationsView,
      meta: {
        title: gettext.$gettext("No organizations"),
      },
    },
    ...PublicRouter,
    AppRouter,
  ],
});

router.beforeEach(BeforeEach);

export default router;
